import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const shipmentOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: '经销商',
            prop: 'distributorId',
            formsolt: true,
            hide: true,
        },
        {
            label: '产品',
            prop: 'goods',
            formsolt: true,
            hide: true,
        },
        {
            label: "出货详情",
            prop: "constitute",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "出货单编号",
            prop: "shipmentNum",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "商品名称",
            prop: "productName",
            type: "input",
            formatter: function (row, value, label, column) {
                let a = row.productName
                let arr = a.split(',')
                for (let i of arr) {
                    if (i.length > 10) {
                        i = i.slice(0, 9) + ".."
                        return i
                    }
                }
                return arr.join("</br>")
            },
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "经销商姓名",
            prop: "dealerName",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "经销商账号",
            prop: "account",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "出货数总量",
            prop: "totalNumber",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "出货时间",
            prop: "shipmentTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "状态",
            prop: "status",
            search: true,
            type: 'select',
            dicData: DIC.SHIPMENT_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
            //hide: true
        },
        {
            label: "出货人",
            prop: "createBy",
            search: true,
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
            //hide: true
        },
        {
            label: "出货时间",
            prop: "startTime_endTime",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            hide: true,
            search: true,
            clearable: true,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },

    ]
};